export const AGREEMENT = 'agreement'
export const CONTRACT_SEAL_APPLICATION = 'contract_seal_application'
export const GENERATE_CONTRACT_CHILD = 'generate_contract_child'
export const F_BLOGGER_RECORDS = 'f_blogger_records'
export const COURSE_WITHOUT_STOCK = "course_without_stock" // 
export const CLOSE = 'close'
export const EXPENSE = 'expense'